import { gql } from '@apollo/client';
import { POLICY_FIELDS_FRAGMENT } from './fragments';

/**
 * Get single policy by ID
 */
export const GET_POLICY = gql`
  ${POLICY_FIELDS_FRAGMENT}
  query GetPolicy($tenantId: String!, $policyId: String!) {
    getPolicy(tenantId: $tenantId, policyId: $policyId) {
      ...PolicyFields
    }
  }
`;

/**
 * List policies with pagination
 */
export const LIST_POLICIES = gql`
  ${POLICY_FIELDS_FRAGMENT}
  query ListPolicies($tenantId: String!, $limit: Int, $cursor: String) {
    listPolicies(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...PolicyFields
      }
      nextCursor
      hasMore
    }
  }
`;

/**
 * List policies by type (Approval, Validation, Security, Compliance, Notification)
 */
export const LIST_POLICIES_BY_TYPE = gql`
  ${POLICY_FIELDS_FRAGMENT}
  query ListPoliciesByType($tenantId: String!, $policyType: PolicyType!, $limit: Int, $cursor: String) {
    listPoliciesByType(tenantId: $tenantId, policyType: $policyType, limit: $limit, cursor: $cursor) {
      items {
        ...PolicyFields
      }
      nextCursor
      hasMore
    }
  }
`;

/**
 * List policies by scope (Workflow, Task, Approval, Global)
 */
export const LIST_POLICIES_BY_SCOPE = gql`
  ${POLICY_FIELDS_FRAGMENT}
  query ListPoliciesByScope($tenantId: String!, $scope: PolicyScope!, $limit: Int, $cursor: String) {
    listPoliciesByScope(tenantId: $tenantId, scope: $scope, limit: $limit, cursor: $cursor) {
      items {
        ...PolicyFields
      }
      nextCursor
      hasMore
    }
  }
`;

/**
 * List only enabled policies
 */
export const LIST_ENABLED_POLICIES = gql`
  ${POLICY_FIELDS_FRAGMENT}
  query ListEnabledPolicies($tenantId: String!, $limit: Int, $cursor: String) {
    listEnabledPolicies(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...PolicyFields
      }
      nextCursor
      hasMore
    }
  }
`;

/**
 * Evaluate policy against context
 */
export const EVALUATE_POLICY = gql`
  query EvaluatePolicy($tenantId: String!, $policyId: String!, $input: EvaluatePolicyInput!) {
    evaluatePolicy(tenantId: $tenantId, policyId: $policyId, input: $input) {
      policyId
      decision
      matchedRules
      actionsTriggered
      evaluationTimeMs
      auditTrail
    }
  }
`;

/**
 * Validate policy rules before creation/update
 */
export const VALIDATE_POLICY_RULES = gql`
  query ValidatePolicyRules($tenantId: String!, $rules: [PolicyRuleInput!]!) {
    validatePolicyRules(tenantId: $tenantId, rules: $rules) {
      valid
      errors
      warnings
    }
  }
`;
